import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from '@printdeal/ui-library';

interface InstructionsReOrderAlertProps {
  validLineItemsCount: number;
  hasValidFiles: boolean;
  hasInvalidFiles: boolean;
}
const InstructionsReOrderAlert = ({
  validLineItemsCount,
  hasValidFiles,
  hasInvalidFiles,
}: InstructionsReOrderAlertProps) => {
  if (validLineItemsCount === 0) {
    return null;
  }

  if (hasInvalidFiles) {
    return (
      <Alert variant="info">
        <FormattedMessage
          id="account.order.reorder.body.with.file.expired"
          defaultMessage="{count, plural, one {The file of the product you are trying to add to the cart has expired, that's why you're unable to reorder with file} other {One or more of the files associated with one of the ({count}) products you're trying to add to your cart has expired}}"
          values={{ count: validLineItemsCount }}
        />
      </Alert>
    );
  }

  if (hasValidFiles) {
    return (
      <FormattedMessage
        id="account.order.reorder.body.with.file"
        defaultMessage="{count, plural, one {Do you want to keep the previous design while adding the product to the cart} other {Do you want to keep previous designs while adding products ({count}) to the cart}}"
        values={{ count: validLineItemsCount }}
      />
    );
  }

  return (
    <FormattedMessage
      id="account.order.reorder.body.without.file"
      defaultMessage="{count, plural, one {Are you sure you want to add the product to the cart} other {Are you sure you want to add the products ({count}) to the cart}}"
      values={{ count: validLineItemsCount }}
    />
  );
};

export default InstructionsReOrderAlert;
